import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetGrupos = async (idruta) => {
  const rs = await request(API_ROUTES.getGroups(idruta), { method: "GET" });
  return rs.json();
};

export const apiGetGroupById = async (id) => {
  const res = await request(API_ROUTES.getGroupsById(id), { method: "GET" });
  return await res.json();
};

export const apiSaveGroup = async (form) => {
  const isUpdate = !!form.id;
  const res = await request(API_ROUTES.saveGroup, {
    method: isUpdate ? "PUT" : "POST",
    body: JSON.stringify(form),
  });

  return res.json();
};
